/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_Polish_Desc6Inputs */

const en_svc_mobile_app_development_polish_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Polish_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haptics, transitions, and gestures tuned to each platform's conventions, nothing feels web-in-a-shell.`)
};

const ar_svc_mobile_app_development_polish_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Polish_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استجابة لمسية وانتقالات وإيماءات مضبوطة على عرف كل منصة، ولا شيء يبدو كصفحة ويب مُغلَّفة.`)
};

const bn_svc_mobile_app_development_polish_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Polish_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রতিটি প্ল্যাটফর্মের কনভেনশনে টিউন করা হ্যাপটিক্স, ট্রানজিশন ও জেসচার, কিছুই ওয়েব-ইন-এ-শেল মনে হয় না।`)
};

const de_svc_mobile_app_development_polish_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Polish_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haptik, Übergänge und Gesten, abgestimmt auf die Konventionen der jeweiligen Plattform, nichts wirkt wie eine lieblos verpackte Website.`)
};

const es_svc_mobile_app_development_polish_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Polish_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hápticas, transiciones y gestos adaptados a las convenciones de cada plataforma, nada parece una web empaquetada.`)
};

const fr_svc_mobile_app_development_polish_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Polish_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haptiques, transitions et gestes adaptés aux conventions de chaque plateforme, aucune sensation de site emballé.`)
};

const pt_svc_mobile_app_development_polish_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Polish_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tátil, transições e gestos ajustados às convenções de cada plataforma, nada parece uma web empacotada.`)
};

const zh_svc_mobile_app_development_polish_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Polish_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`触感、转场和手势都按各平台习惯调过，没有一点套壳网页的感觉。`)
};

const tr_svc_mobile_app_development_polish_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Polish_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her platformun kurallarına ayarlı dokunma, geçiş ve hareketler, hiçbir şey kabuk site hissi vermez.`)
};

const ru_svc_mobile_app_development_polish_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Polish_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хаптика, переходы и жесты под конвенции каждой платформы, ничто не выглядит как завёрнутый сайт.`)
};

const pl_svc_mobile_app_development_polish_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Polish_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haptyka, przejścia i gesty dostrojone do konwencji każdej platformy, nic nie wygląda jak opakowana stronka.`)
};

/**
* | output |
* | --- |
* | "Haptics, transitions, and gestures tuned to each platform's conventions, nothing feels web-in-a-shell." |
*
* @param {Svc_Mobile_App_Development_Polish_Desc6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_polish_desc6 = /** @type {((inputs?: Svc_Mobile_App_Development_Polish_Desc6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_Polish_Desc6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_polish_desc6(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_polish_desc6(inputs)
	if (locale === "de") return de_svc_mobile_app_development_polish_desc6(inputs)
	if (locale === "es") return es_svc_mobile_app_development_polish_desc6(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_polish_desc6(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_polish_desc6(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_polish_desc6(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_polish_desc6(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_polish_desc6(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_polish_desc6(inputs)
	return en_svc_mobile_app_development_polish_desc6(inputs)
});
export { svc_mobile_app_development_polish_desc6 as "svc_mobile-app-development_POLISH_desc" }